(() => {
if (window.TBOpenStudio) return;
let expiry;
const sweep=() => {
  clearTimeout(expiry); let next=Date.now() + 900000;
  try { for (const key of Object.keys(sessionStorage)) if (key.startsWith('tb-editor-draft-v3:')) {
    const end=Number(/"expires":(\d+)/.exec(sessionStorage.getItem(key).slice(0,120))?.[1]);
    if (!end || end <= Date.now()) sessionStorage.removeItem(key); else next=Math.min(next,end);
  } } catch (_) {}
  expiry=setTimeout(sweep,Math.max(1,next-Date.now()));
};
addEventListener('pageshow',sweep); addEventListener('focus',sweep); sweep();
let pending;
window.TBOpenStudio=async el => {
  if (!el) return;
  const button=el.querySelector('[data-open-studio]');
  button.disabled=true; button.setAttribute('aria-busy', 'true');
  try {
    if (!pending) pending=new Promise((resolve, reject) => {
      const script=document.createElement('script'), css=document.createElement('link');
      script.src=window.TBStudioAssets?.['tb-a-editor.js'] || el.dataset.src; css.rel='stylesheet';
      const cssURL=new URL('tb-a-editor.css', script.src); cssURL.search=new URL(script.src).search; css.href=window.TBStudioAssets?.['tb-a-editor.css'] || cssURL.href;
      script.onload=resolve;
      css.onload=() => document.head.append(script);
      css.onerror=script.onerror=() => { script.remove(); css.remove(); pending=null; reject(Error('studio')); };
      document.head.append(css);
    });
    await pending; await customElements.whenDefined('tb-a-editor');
    await el.open();
  } catch (_) {
    const error=el.querySelector('[data-editor-error]');
    error.textContent=el.closest('tb-a-product')?.config?.strings.upload_network || 'Riprova'; error.hidden=false;
  } finally { button.disabled=false; button.removeAttribute('aria-busy'); }
};
document.addEventListener('click', event => {
  const button=event.target.closest('[data-open-studio]');
  if (button) window.TBOpenStudio(button.closest('tb-a-editor'));
});
if(location.hash.startsWith('#tb-design='))TBOpenStudio(document.querySelector('tb-a-editor'));
})();
